import { FC, memo } from "react";
import { StreamStateView } from "./StreamStateView";

type StreamErrorViewProps = {
  onRetry: () => void;
};

export const StreamErrorView: FC<StreamErrorViewProps> = memo(({ onRetry }) => (
  <StreamStateView
    title="Unable to play stream"
    message="Something went wrong while loading the live stream. Please try again."
    onRetry={onRetry}
  />
));

StreamErrorView.displayName = "StreamErrorView";
